/**
 * @file index.tsx
 *
 * @fileoverview Renders a Job list for the split view sidebar.
 *
 * This component receives a list of jobs from the jobs page and will display a
 * list for the side bar of jobs using for each one the teaser component provided in jobiqo-cl.
 */

import React from 'react';
import { Job } from '~/jobiqo/types/types';
import JobTeaserCard from '~/jobiqo/components/Job/Teaser';
import {
  getJobAppendUrl,
  isActiveJob,
} from '~/jobiqo/components/JobSearch/SplitView/utils/splitViewUtils';
import AdUnitMediumRectangleSlot from '~/jobiqo/components/Slots/AdUnitMediumRectangleSlot';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { useJobSearch } from '~/jobiqo/context/jobSearch';

interface JobsListProps {
  /**
   * The job list to display.
   */
  jobs: Job[];
  /**
   * If user is on mobile page.
   *
   * @default "false"
   */
  isMobile?: boolean;
  /**
   * The current querystring.
   */
  querystring: any;
  /**
   * The current pathname.
   */
  pathname: string;
  /**
   * The current path.
   */
  path: string;
  /**
   * Force context-based split-view routing outside the default jobs page.
   */
  shallowJobSearch?: boolean;
}

const JobsSideList = ({
  jobs,
  querystring,
  pathname,
  path,
  shallowJobSearch = false,
}: JobsListProps) => {
  const { currentJobId } = useJobSearch();
  const { JOBS } = useFrontendConfig();
  const JOB_SEARCH_ADS_TEASER_FREQUENCY = JOBS.JOB_SEARCH_ADS_TEASER_FREQUENCY;
  return (
    <div>
      {jobs.map((job, index) => {
        const urlObject = getJobAppendUrl(job, querystring, pathname, path);
        return (
          <div key={index}>
            {index !== 0 && index % JOB_SEARCH_ADS_TEASER_FREQUENCY === 0 && (
              <AdUnitMediumRectangleSlot listIndex={index} />
            )}
            <JobTeaserCard
              active={isActiveJob(job, currentJobId)}
              job={job}
              route={urlObject.route}
              as={urlObject.as}
              shallowJobSearch={shallowJobSearch}
            />
          </div>
        );
      })}
    </div>
  );
};

export default JobsSideList;
